/**
 * Documentación:
 * 
 * Este archivo contiene el componente FormularioVehicular, que representa un formulario para realizar
 * consultas relacionadas con registros vehiculares.
 * 
 * El formulario recopila información como el nombre, el primer apellido, el segundo apellido, la razón social,
 * la placa y el teléfono del propietario del vehículo.
 * 
 * Una vez que se completa el formulario y se envía, se realiza una llamada al endpoint del backend
 * '/api/vehicular' para enviar la información ingresada. Luego, el componente espera la respuesta
 * del backend y llama a la función submitCallback con los resultados obtenidos.
 * 
 * Además, el componente realiza validaciones básicas de los campos antes de enviar la solicitud al backend.
 * Si hay un error durante el proceso de envío de la solicitud o si se recibe una respuesta de error del backend,
 * se maneja el error y se muestra un mensaje de error al usuario.
 */

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import {  useNavigate } from "react-router-dom";
// Definición del componente funcional FormularioVehicular
const FormularioVehicular = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [placa, setPlaca] = useState('');
  const [telefono, setTelefono] = useState('');
  const [processing] = useState(false); 
  const [error] = useState(null); 
  const navigate = useNavigate() 

const handleSubmit = (e) => {
  e.preventDefault();
  const busqueda= `/busqueda?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&razonSocial=${razonSocial}&placa=${placa}&telefono=${telefono}`
  navigate(busqueda)
  
};


  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Razón Social:
          <input type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Placa:
          <input type="text" value={placa} onChange={(e) => setPlaca(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Teléfono:
          <input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        </label>
      </div>
      {/* Botón de envío del formulario */}
      <button  className='button2' type="submit" disabled={processing}>
        {processing ? 'Buscando...' : 'Buscar'}
      </button>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className="error-message">{error}</div>}
    </form>
  );
};

// Exportar el componente FormularioVehicular
export default FormularioVehicular;

